export const saveRedirectOrigin = origin => {
	if (origin !== '/') {
		window.localStorage.redirectedFrom = origin;
	}
};



// WEBPACK FOOTER //
// ./src/utils/saveRedirectOrigin.js